package location

import androidx.compose.runtime.Composable

actual fun PlatformGeoLocation(): GeoLocation = WebGeoLocation()

@Composable
actual fun GeoLocationPlatformBindings() {
    // no-op for web
}